// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  mashery_api_key: "f9ktcsyxysvqd6q53m5bs29v",
  mashery_api_secret: "9P3Un4z94S",
  mashery_otp_url: "http://10.64.46.80/eai/verify_customer/otp",
  allowed_origin:"https://testpdp-ioh.ioh.co.id",
  im3HomePage:"https://indosatooredoo.com/id/personal/myim3/deeplink?action=openexternaldeeplink&url=https%3A%2F%2Fmyim3.app.link%2Fpdppageexit",
  bimaHomePage:"https://bimaplus.tri.co.id/en/deeplink?action=page&pagename=pdppageexit"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
